import { LOCALES } from "utils/constants";

const translation = {
    [LOCALES.FA]: {
        WRITTEN_BY: "تالیف",
        TRANSLATION: "ترجمه",
        PAGE_COUNT: "تعداد صفحه",
        PREVIEW_LINK: "پیش نمایش",
        PURCHASE_LINK: "لینک خرید",
    },
    [LOCALES.EN]: {
        WRITTEN_BY: "Written by",
        TRANSLATION: "Translation",
        PAGE_COUNT: "Number of pages",
        PREVIEW_LINK: "Preview",
        PURCHASE_LINK: "Purchase link",
    },
} as const;

export default translation;
